import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * å»é¢çåç±»éç½®
 */
@JsonObject
export class TenantAttr {
  /**
   * å·ä½åç±»éç½®
   */
  @JsonProperty('classificationId', Number)
  classificationId: number = undefined;

  /**
   * åç±»éç½®çéé¡¹
   */
  @JsonProperty('options', [Number])
  options: number[] = undefined;
}
